module.exports = __webpack_public_path__ + "static/nhan_quan_21-f17cb7c344a1d6ded6030c6133116255.jpg";